import { NavigationMenu as BaseNavigationMenu } from "@base-ui-components/react/navigation-menu";
import {
  navigationMenuIconClasses,
  navigationMenuTriggerClasses,
} from "./NavigationMenu.style";
import { ChevronDownIcon } from "lucide-react";

type BaseNavigationMenuProps = BaseNavigationMenu.Trigger.Props;

const NavigationMenuTrigger = (props: BaseNavigationMenuProps) => {
  const { children, className, ...rest } = props;
  const resolvedClassName =
    typeof className === "function" ? className({ open: false }) : className;

  return (
    <BaseNavigationMenu.Trigger
      className={navigationMenuTriggerClasses({ class: resolvedClassName })}
      {...rest}
    >
      {children}
      <BaseNavigationMenu.Icon className={navigationMenuIconClasses()}>
        <ChevronDownIcon size={18} />
      </BaseNavigationMenu.Icon>
    </BaseNavigationMenu.Trigger>
  );
};

export default NavigationMenuTrigger;
